<template>
  <footer :class="['p-4 md:p-12 lg:p-[48px]', !$_inscriptionFormMixin_routesStatus.includes($route.name) ? 'bg-[#1A1E24]' : null]">
    <div>
      <!-- Top Section -->
      <div class="py-6">
        <div :class="[$_inscriptionFormMixin_routesStatus.includes($route.name) ? 'text-center' : null, 'text-[#6F8399]']">
          Powered by <span class="text-[#CCD5DF] font-medium">OWQLO</span>
        </div>
      </div>
      
      <!-- Divider Line -->
      <hr class="border-[#3A424B] w-full">
      
      <!-- Bottom Section -->
      <div class="py-6 flex flex-col sm:flex-row justify-start sm:justify-between items-start sm:items-center">
        <div class="text-[#6F8399] text-sm mb-6 sm:mb-0">
          © {{ year }} OWQLO. Operated by GOWVO Connection Events S.L. as Merchant of Record. Platform owned by Tech Smart Sports Connector Corp.
        </div>
        <div class="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-6 text-[#6F8399] text-sm items-start sm:items-center">
          <template v-if="$route.name === 'inscription-landing'">
            <a
              href="https://www.gowo.es/terminos-y-condiciones"
              class="hover:text-[#CCD5DF] transition-colors"
              v-text="$t('common.termsAndConditions')"
            />
            <a
              href="https://www.gowo.es/politica-de-privacidad"
              class="hover:text-[#CCD5DF] transition-colors"
              v-text="$t('common.privacyPolicy')"
            />
          </template>
          <template v-else>
            <a 
              v-for="(link, index) in dynamicFormTemplate?.footerLinks" 
              :key="`footer-link-${index}`"
              :href="link.url" 
              target="_blank" 
              class="hover:text-[#CCD5DF] transition-colors"
              v-text="link.name"
            />
          </template>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState } from 'pinia'
import { useDynamicFormStore } from '@/store/dynamicFormStore'
import { useProjectStore } from '@/store/projectStore'
import inscriptionFormMixin from '@/shared/utils/mixins/inscriptionFormMixin.js'

export default {
  name: 'TheFooter',
  mixins: [inscriptionFormMixin],
  computed: {
    ...mapState(useDynamicFormStore, { dynamicFormTemplate: 'dataUser' }),
    ...mapState(useProjectStore, ['project']),
  },
  data:() => ({
    year: new Date().getFullYear(),
  }),
}
</script>
